import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { ContactAlternativeInfoComponent } from './contact-alternative-info.component';

@NgModule({
  declarations: [ContactAlternativeInfoComponent],
  imports: [CommonModule, FormsModule, NgSelectModule, DialogModule, TooltipModule, PipeDirectiveModule],
  exports: [ContactAlternativeInfoComponent],
})
export class ContactAlternativeInfoModule {}
